import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { DatePicker } from "antd";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import Table from "../../Components/TableTemplate/Table";
import {
  dateFormat,
  // getRestoLogin,
  getRole,
  numberWithCommas,
  refreshPage,
  // toastStyle,
} from "../../Helpers/Utils/Common";
import { getModifierReport } from "../../Helpers/apiCalls/reportsAPI";
import ModifierPdf from "../../Components/Print/ModifierSalesReportPdf";
import PrintCategory from "../../Components/Print/PrintCategory";
import { useNavigate } from "react-router-dom";
import {
  // printBase64,
  printAsTextFile,
} from "../../Helpers/apiCalls/paymentAPI";
import { DownloadTableExcel } from "react-export-table-to-excel";
// import imageCompression from "compressorjs";
// import toast from "react-hot-toast";
import { UseGetRequest } from "../../Helpers/hooks/GetRequests";
import moment from "moment";

const { RangePicker } = DatePicker;
function CategoryReport() {
  const role = getRole();
  const dateToday = moment().format("YYYY-MM-DD");
  // const [restoType, setRestoType] = useState(getRestoLogin());
  const navigate = useNavigate();
  const [inactive, setInactive] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [totals, setTotals] = useState({});
  const [totalSales, setTotalSales] = useState();
  const [categories, setCategories] = useState([]);
  const [openPDF, setOpenPDF] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [selectedtab, setSelectedTab] = useState("daily");
  const [filter, setFilter] = useState({
    date_from: new Date().toLocaleDateString("en-CA"),
    date_to: new Date().toLocaleDateString("en-CA"),
    category_id: "all",
    pricelist: "",
  });

  const componentExportPDF = useRef();
  const handleOpen = () => {
    setOpenPDF(true);
  };

  // Handle for export to pdf
  const handleExportPDF = (e) => {
    if (e === "pdf-1") {
      // const pdf = new jsPDF();
      // const content = componentExportPDF.current;
      // html2canvas(content).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png");
      //   const imgWidth = 200; // Set the width of the image (A4 size)
      //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
      //   const x = (pdf.internal.pageSize.width - imgWidth) / 2;
      //   pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
      //   pdf.save("Modifier Sales Report.pdf");
      // });

      const pdf = new jsPDF();
      const content = componentExportPDF.current;

      html2canvas(content).then((canvas) => {
        const imgWidth = 200; 
        // const pageHeight = pdf.internal.pageSize.height; 
        const pageHeight = 280; 
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Scaled height of the image
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;

        let heightLeft = canvasHeight;
        let position = 0;

        while (heightLeft > 0) {
          const canvasSection = document.createElement("canvas");
          canvasSection.width = canvasWidth;
          canvasSection.height = Math.min(heightLeft, (pageHeight * canvasWidth) / imgWidth);

          const ctx = canvasSection.getContext("2d");
          ctx.drawImage(canvas, 0, position, canvasWidth, canvasSection.height, 0, 0, canvasWidth, canvasSection.height);

          const sectionData = canvasSection.toDataURL("image/png");
          const x = (pdf.internal.pageSize.width - imgWidth) / 2;

          pdf.addImage(sectionData, "PNG", x, 10, imgWidth, (canvasSection.height * imgWidth) / canvasWidth);

          heightLeft -= canvasSection.height;
          position += canvasSection.height;

          if (heightLeft > 0) {
            pdf.addPage();
          }
        }

        pdf.save("Modifier Sales Report.pdf");
      });   
      setOpenPDF(false);
    }
    // else {
    //   const pdf = new jsPDF();
    //   const content = cancelledPdfRef.current;
    //   html2canvas(content).then((canvas) => {
    //     const imgData = canvas.toDataURL("image/png");
    //     const imgWidth = 200; // Set the width of the image (A4 size)
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //     const x = (pdf.internal.pageSize.width - imgWidth) / 2;
    //     pdf.addImage(imgData, "PNG", x, 10, imgWidth, imgHeight);
    //     pdf.save("Category Sales Report.pdf");
    //   });
    //   setOpenPDF(false);
    // }
  };

  //fetch category
  async function fetchAllCategories() {
    const response = await UseGetRequest("menus/search", {is_modifier: 1});
    if (response.data) {
      setCategories(response.data.menus);
    }
  }

  //fetch category
  async function fetchTableData() {
    setShowLoader(true);
    const response = await getModifierReport(filter);
    if (response.data) {
      let table_data_item = response.data.data.items.map((data) => {
        return {
          data,
          amount: numberWithCommas(data.amount),
          category: data.category,
          category_id: data.category_id,
          total_amount: numberWithCommas(data.total_amount),
          menu_name: data.menu_name,
          total_qty: data.total_qty,
        };
      });

      setTotalSales(
        response.data.data.items
          .map((data) => parseFloat(data.total_amount))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );

      setTableData(table_data_item);
      setReportData(response.data.data.items);
      setTotals(response.data.data);
    } else {
      setTotalSales(0);
      setTableData([]);
      setReportData([]);
      setTotals({});
    }
    setShowLoader(false);
  }

  const handleFilter = (e) => {
    const { name, value } = e.target;
    var filtercopy = { ...filter };
    filtercopy[name] = value;
    setFilter(filtercopy);
  };

  //handle for tab selection
  const handleTabSelect = (tabKey) => {
    setSelectedTab(tabKey);
  };
  const csvRef = useRef();

  const printRef = useRef(null); // Initialize useRef with null
  const [allowPrint, setAllowPrint] = useState(false);
  const handleOpenPrint = () => {
    setAllowPrint(true);
  };

  const handlePrint = () => {
    if (printRef.current) {
      const element = printRef.current;

      html2canvas(element, { scale: 1 }).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const blob = new Blob([imgData], { type: "text/plain" });
        const txtFile = new File([blob], "data.txt", { type: "text/plain" });
        // const newWindow = window.open();
        // if (newWindow) {
        //   newWindow.document.write(`<img src="${imgData}" alt="Captured Image"/>`);
        //   newWindow.document.close();
        // }
        handlePrintTextFile(txtFile);
      });
    }
  };

  async function handlePrintTextFile(textFile) {
    const response = await printAsTextFile(
      window.printer_name,
      textFile,
      "0",
    );
    if (response.data) {
      setAllowPrint(false);
      setAllowPrint(false);
      refreshPage();
    } else {
      setAllowPrint(false);
    }
  }

  // async function printBase64Data(image) {
  //   const response = await printBase64(
  //     window.printer_name,
  //     image,
  //     "0",
  //     restoType
  //   );
  //   if (response.data) {
  //     setAllowPrint(false);
  //     setAllowPrint(false);
  //     refreshPage();
  //   } else {
  //     setAllowPrint(false);
  //   }
  // }

  /** EXPORT */
  function handleToCSV() {
    return (
      <DownloadTableExcel
        filename="Modifier Report"
        sheet="users"
        currentTableRef={csvRef.current}
      >
        <button className=" category-new-export-btn">Export to CSV</button>
      </DownloadTableExcel>
    );
  }

  //useeffects
  useEffect(() => {
    if (allowPrint === true) {
      handlePrint();
    }
  }, [allowPrint]);

  useEffect(() => {
    fetchTableData();
  }, [filter]);

  useEffect(() => {
    fetchAllCategories();
  }, []);

  useEffect(() => {
    if (openPDF === true) {
      handleExportPDF("pdf-1");
    } else {
      setOpenPDF(false);
    }
  }, [openPDF]);

  return (
    <div>
      <NavbarAdmin
        onCollapse={(inactive) => {
          setInactive(inactive);
        }}
        active={"Reports"}
        page={"Reports"}
      />
      <div
        className={`container px-5 py-2 bold-font ${
          getRole() === "" ? "cashier" : inactive ? "inactive" : "active"
        }`}
      >
        <Row>
          <Col>
            <label className="page-title-menu"> MODIFIER REPORT </label>
          </Col>
          <Col className="">
            {tableData.length > 0 && (
              <Row>
                <Col>
                  {/* <button
                    className="category-new-export-btn"
                    value="print"
                    onClick={handleOpenPrint}
                  >
                    Print
                  </button> */}
                </Col>
                <Col>
                  <button
                    className="category-new-export-btn"
                    value="pdf-1"
                    onClick={handleOpen}
                  >
                    Export to PDF
                  </button>
                </Col>
                &nbsp;&nbsp;
                {/* {(role === "1" || role === "7") && <Col>{handleToCSV()}</Col>} */}
                {role === "2" && (
                  <Col>
                    <button
                      className="category-new-export-btn"
                      value="pdf-1"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </button>
                  </Col>
                )}
              </Row>
            )}
          </Col>
        </Row>
        <Row>
          <Tabs
            defaultActiveKey="daily"
            transition={false}
            onSelect={handleTabSelect}
          >
            <Tab eventKey="daily" title="Summary">
              <Row className="pt-3 PO-filters">
                <Col xs={2} className="cat-container">
                  {/* <label className="select-label">Filter by Category:</label> */}
                  <select
                    id="category_id"
                    name="category_id"
                    className="responsive-select"
                    onChange={handleFilter}
                  >
                    <option value={"all"}>All</option>
                    {categories.map((category) => {
                      return (
                        <>
                          <option value={category.menu_id}>{category.menu_item_name}</option>
                        </>
                      );
                    })}
                  </select>
                </Col>
                <Col xs={3}>
                  <RangePicker
                    onChange={(e) => {
                      if (e) {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: e[0].format("YYYY-MM-DD"),
                          date_to: e[1].format("YYYY-MM-DD"),
                        }));
                      } else {
                        setFilter((prev) => ({
                          ...prev,
                          date_from: dateToday,
                          date_to: dateToday,
                        }));
                      }
                    }}
                    placeholder={[dateToday, dateToday]}
                    className="w-100 h-100"
                  />
                </Col>
                {/* <Col xs={3} className="cat-container">
                  <select
                    placeholder="Pricelist"
                    id="pricelist"
                    name="pricelist"
                    className="responsive-select"
                    onChange={handleFilter}
                  >
                    <option value={""}>All</option>
                    <option value={"store"}>Store</option>
                    <option value={"foodpanda"}>Food Panda</option>
                    <option value={"grab"}>Grab</option>
                  </select>
                </Col> */}
              </Row>
              <Row className="mt-2">
                <h5>Total Sales : &nbsp;{numberWithCommas(totalSales)}</h5>
                <Col>
                  <Table
                    tableHeaders={[
                      "ITEM NAME",
                      "QTY",
                      // "AMOUNT",
                      "TOTAL AMOUNT",
                    ]}
                    headerSelector={[
                      "menu_name",
                      "total_qty",
                      // "amount",
                      "total_amount",
                    ]}
                    tableData={tableData}
                    showLoader={showLoader}
                  />
                </Col>
              </Row>
            </Tab>
          </Tabs>
        </Row>

        <div className="hide-from-screen">
          {/* <div ref={printRef}>
            <div className="d-flex justify-content-center">
              <PrintCategory
                tab={selectedtab}
                data2={reportData}
                data={tableData}
                totalSales={totalSales}
                filter={filter}
                totals={totals}
              />
            </div>
          </div> */}
          </div>
          <div className="custom-hide">
          <div ref={componentExportPDF}>
            <div className="">
              <ModifierPdf
                ref={componentExportPDF}
                tab={selectedtab}
                data={tableData}
                data2={reportData}
                filter={filter}
                totals={totals}
              />
            </div>
          </div>
        </div>
      </div>

      {/* CSV COMPONENT */}
      <div className="custom-hide">
        <Row>
          <div className="row" ref={csvRef}>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_name}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_address}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {" "}
                {window.company_vat_reg_tin}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_min}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_sn}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.company_ptu_no}
              </label>
            </div>
            <div className="d-flex row justify-content-center">
              <label className="d-flex row justify-content-center print-text-category">
                {window.issued_date}
              </label>
            </div>
            <table className="table table-bordered left ms-5 ">
              <thead></thead>
              <tbody>
                <tr>
                  <th colSpan={3} className="print-text-category">
                    MODIFIER REPORTS
                  </th>
                </tr>
                <tr>
                  <th colSpan={3} className="print-text-category">
                    DATE FROM: {dateFormat(new Date(filter.date_from))}
                  </th>
                </tr>
                <tr>
                  <th colSpan={3} className="print-text-category">
                    DATE TO: {dateFormat(new Date(filter.date_to))}
                  </th>
                </tr>
                <tr>
                  <th className="print-text-category">MODIFIER NAME</th>
                  <th className="print-text-category">QTY</th>
                  <th className="print-text-category">TOTAL AMOUNT</th>
                </tr>
                {reportData
                  .filter((info) => info.items && info.items.length > 0)
                  .map((data) => {
                    return (
                      <>
                        {data.items &&
                          data.items.map((item) => (
                            <tr key={data.name}>
                              <td className="print-text-category">
                                {item.menu_name}{" "}
                              </td>
                              <td className="print-text-category">
                                {item.total_qty}{" "}
                              </td>
                              <td className="print-text-category">
                                {item.total_amount}
                              </td>
                            </tr>
                          ))}
                      </>
                    );
                  })}
                <tr>
                  <br></br>
                </tr>
                {/* <tr>
                  <td>
                    <strong className="print-text-category">
                      SUBTOTAL: {totals?.subtotal || 0.00}
                    </strong>
                  </td>
                </tr> */}
                {/* <tr>
                  <td>
                    <strong className="print-text-category">
                      B1T1: {totals?.less_discount || 0.00}
                    </strong>
                  </td>
                </tr> */}
                <tr>
                  <td>
                    <strong className="print-text-category">
                      GRAND TOTAL: {totals?.total_sales || 0.00}
                    </strong>
                  </td>
                </tr>
                <tr></tr>
              </tbody>
            </table>
          </div>
        </Row>
      </div>
    </div>
  );
}

export default CategoryReport;
